import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      MEAL: "Middag",
      MEALS: "middager",
      WEEK: "uke",
      PEOPLE: "personer",

      PORTION: "porsjon",
      PORTIONS: "porsjoner",
      REACTIVATE_AND_CHANGE_DISHES: "Reaktiver og velg middager",
      CHANGE_DISHES: "Velg retter selv",
      VIEW_DISHES: "Vis retter",
      SUGGESTIONS_BASED_ON: "Middagsforslag basert på ",
      YOUR_PREFERENCES: "dine matpreferanser",
      YOU_HAVE_CHOSEN_YOURSELF: "Du har valgt middager selv",
      RECIPE: "oppskrift",
      TO_BOOK_ON_WEEK: "For å bestille middager til leveringsuke",
      YOUR_MENU_CONTAINS_NON_COMPLIANT_PRODUCTS:
        "Din meny inneholder en eller flere retter som ikke samsvarer med dine preferanser, og kan inneholde allergener.",
    },
    se: {
      MEAL: "Middag",
      WEEK: "vecka",
      YOUR_DISHES: "Dina middagar",
      MEALS: "middagar",
      PEOPLE: "personer",

      PORTION: "portion",
      PORTIONS: "portioner",
      REACTIVATE_AND_CHANGE_DISHES: "Återaktivera och välj middagar",
      CHANGE_DISHES: "Välj rätter själv",
      VIEW_DISHES: "Visa rätter",
      SUGGESTIONS_BASED_ON: "Middagsförslag baserat på",
      YOUR_PREFERENCES: "dina matpreferenser",
      YOU_HAVE_CHOSEN_YOURSELF: "Du har valt middagar själv.",
      RECIPE: "recept",
      TO_BOOK_ON_WEEK: "För att boka på leverans v.",
      YOUR_MENU_CONTAINS_NON_COMPLIANT_PRODUCTS:
        "Din meny innehåller en eller flera rätter som inte stämmer överens med dina preferenser, och kan innehålla allergener.",
    },
    dk: {
      MEAL: "Middag",
      WEEK: "uge",
      YOUR_DISHES: "Dine retter",
      MEALS: "retter",
      PEOPLE: "personer",

      PORTION: "portion",
      PORTIONS: "portioner",
      REACTIVATE_AND_CHANGE_DISHES: "Genaktiver og vælg retter",
      CHANGE_DISHES: "Ændr retter",
      VIEW_DISHES: "Vis retter",
      SUGGESTIONS_BASED_ON: "Måltidsforslag baseret på ",
      YOUR_PREFERENCES: "dine præferencer",
      YOU_HAVE_CHOSEN_YOURSELF: "Du har selv valgt retter",
      RECIPE: "opskrift",
      TO_BOOK_ON_WEEK: "For at bestille en måltidskasse til leveringsuge",
      YOUR_MENU_CONTAINS_NON_COMPLIANT_PRODUCTS:
        "Din menu indeholder én eller flere retter, der ikke er i overensstemmelse med dine præferencer, og kan indeholde allergener.",
    },
  } as const
)[language];
